// General dependencies
import to from 'await-to-js';
import axios, { AxiosError, AxiosResponse } from 'axios';

// Local dependencies
import { Data } from './IHTTP.interface';

// This abstract class includes all the shared logic between FE and BE HttpServices
export abstract class AxiosAbstract {
  _client = axios.create({
    withCredentials: true,
  });

  get = async <T>(endpoint: string, params: Data = {}, headers: Data = {}): Promise<T> => {
    const [err, res] = await to<AxiosResponse<T>, AxiosError>(
      this._client.get<T>(endpoint, {
        headers,
        params,
      })
    );

    if (err) throw err.response || err;

    return res.data;
  };

  post = async <T>(endpoint: string, data: Data = {}, headers: Data = {}): Promise<T> => {
    const [err, res] = await to<AxiosResponse<T>, AxiosError>(
      this._client.post<T>(endpoint, data, { headers })
    );

    if (err) throw err.response || err;

    return res.data;
  };
}

export default AxiosAbstract;
